import clsx from 'clsx';
import { Close } from 'mdi-material-ui';

import { Spinner } from '../Spinner';

const variants = {
	withIntersection: ': ',
	noIntersection: '',
};

const styles = {
	default: 'bg-highlight',
	taggedSearchCriteria: 'bg-taggedSearchCriteria',
	valid: 'bg-valid',
	invalid: 'bg-invalid',
	info: 'bg-infoPanelBackground',
	new: 'bg-active',
	static: 'bg-listStatic',
	dynamic: 'bg-listDynamic',
	hasExclusions: 'bg-hasExclusionsBg',
	noExclusions: 'bg-noExclusionsBg',
};

export type ChipProps = {
	onClose?: () => void;
	name?: string;
	value?: string;
	variant?: keyof typeof variants;
	style?: keyof typeof styles;
	size?: 'sm' | 'md' | 'lg';
	className?: string;
	buttonClassName?: string;
	dataTestId?: string;
	closeDisabled?: boolean;
	isLoading?: boolean;
	icon?: React.ReactNode;
};

export const Chip = (props: ChipProps) => {
	const {
		onClose,
		name,
		value,
		variant = 'withIntersection',
		style = 'default',
		size = 'md',
		className,
		buttonClassName,
		dataTestId,
		closeDisabled,
		isLoading,
		icon,
	} = props;
	return (
		<div
			className={clsx(
				'text-primaryTextDark break-words relative',
				className,
				styles[style],
				size === 'sm' && 'text-sm py-1 px-2 rounded-lg',
				size === 'md' && 'text-sm lg:text-base p-2 rounded-md',
				size === 'lg' && 'text-lg p-3 rounded-md'
			)}
			data-test-id={dataTestId ?? 'chip'}
		>
			{icon && <span className='mr-1 lg:mr-2'>{icon}</span>}
			{name && (
				<span>
					{name}
					{variants[variant]}
				</span>
			)}
			<span className={`${name ? 'font-semibold' : ''}`}>{value}</span>
			{onClose && (
				<button
					type='button'
					className={clsx(
						'float-right',
						buttonClassName,
						closeDisabled ? 'opacity-0' : 'cursor-pointer'
					)}
					onClick={(event) => {
						event.stopPropagation();
						onClose();
					}}
					aria-label={isLoading ? 'Removing...' : 'Remove'}
					disabled={closeDisabled}
				>
					<Close
						fontSize='small'
						className={clsx(size === 'sm' ? 'mx-1' : 'ml-4')}
					></Close>
				</button>
			)}
			{isLoading && (
				<div className='absolute right-3 top-[6px]'>
					<Spinner size='sm' variant='light' className={clsx('text-current')} />
				</div>
			)}
		</div>
	);
};
